import type { WritableDraft } from 'immer/dist/internal';

import type { Feedback, FeedbackShare, FeedbackTopicType, FeedbackUser } from '../../types/feedbacks';
import { createClientAnswer, createClientCommentChild } from './clientSideFeedback';
import { findFeedback } from './findFeedback';

type Args = {
  feedback: WritableDraft<Feedback>;
  content: string;
  ranges: FeedbackShare['ranges'];
  targetId: string;
  userData: FeedbackUser;
  topicType: FeedbackTopicType;
};

export const createClientReply = (args: Args) => {
  const { content, feedback, targetId, userData, topicType, ranges } = args;
  if (!targetId) return;

  switch (feedback.type) {
    case 'Question': {
      const answer = createClientAnswer({ content, user: userData, topicType, ranges });
      feedback.answers = [...(feedback.answers || []), answer];
      break;
    }
    default: {
      const comment = createClientCommentChild({
        content: content,
        user: userData,
        topicType,
        ranges,
      });
      if (targetId === feedback.id) {
        feedback.commentChildren = [...(feedback.commentChildren || []), comment];
      }
      const targetFeedback = findFeedback(feedback.commentChildren, targetId);
      if (targetFeedback) {
        targetFeedback.commentChildren = [...(targetFeedback.commentChildren || []), comment];
      }
    }
  }
};
